import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';

import {
  AuthHttpHeaderService, AuthRedirectService, AuthService, AuthStorageService, AuthToken, GlobalMessageService,
  OAuthLibWrapperService, OccEndpointsService, RoutingService
} from '@spartacus/core';

import { StatusEnum } from '@seb/web-design-system/core';

import { MyAccountService } from './my-account.service';
import { ToasterService } from './toaster.service';

@Injectable({
  providedIn: 'root'
})
export class CustomAuthHttpHeaderService extends AuthHttpHeaderService {
  constructor(
    protected authService: AuthService,
    protected authStorageService: AuthStorageService,
    protected oAuthLibWrapperService: OAuthLibWrapperService,
    protected routingService: RoutingService,
    protected occEndpoints: OccEndpointsService,
    protected globalMessageService: GlobalMessageService,
    private myAccountService: MyAccountService,
    private toasterService: ToasterService,
    authRedirectService: AuthRedirectService
  ) {
    super(
      authService,
      authStorageService,
      oAuthLibWrapperService,
      routingService,
      occEndpoints,
      globalMessageService,
      authRedirectService
    );
  }

  shouldAddAuthorizationHeader(request: HttpRequest<any>): boolean {
    return (
      super.shouldAddAuthorizationHeader(request) &&
      !request.url.includes('/basesites') &&
      !request.url.includes('/basestores') &&
      !request.url.includes('/urlmapping')
    );
  }

  alterRequest(request: HttpRequest<any>, token?: AuthToken): HttpRequest<any> {
    if (this.shouldAddAuthorizationHeader(request)) {
      return request.clone({
        setHeaders: {
          ...this.createAuthorizationHeader(token)
        }
      });
    }
    return request;
  }

  handleExpiredAccessToken(_request: HttpRequest<any>, _next: HttpHandler, _initialToken?: AuthToken): Observable<HttpEvent<AuthToken>> {
    this.handleExpiredRefreshToken();
    return EMPTY;
  }

  handleExpiredRefreshToken(): void {
    this.myAccountService.deleteProfile();
    this.authService.coreLogout().then(() => {
      this.routingService.goByUrl('/');
      this.toasterService.sendToasterEvent({ title: 'account.expiration', status: StatusEnum.info });
    });
  }

  protected createAuthorizationHeader(_token?: AuthToken): { Authorization: string } | Record<string, never> {
    const authorizationHeader = super.createAuthorizationHeader();

    return authorizationHeader['Authorization']
      ? { ...authorizationHeader, Authorization: authorizationHeader['Authorization'] + '.REMOTE' }
      : {};
  }

  protected createNewRequestWithNewToken(request: HttpRequest<any>, token: AuthToken): HttpRequest<any> {
    request = request.clone({
      setHeaders: {
        Authorization: `${token.token_type || 'Bearer'} ${token.access_token}.REMOTE`
      }
    });
    return request;
  }
}
